import app from 'flarum/forum/app';
app.initializers.add('val-ui-legacy-phpbb-links', () => {
  const legacyPaths = ['/viewtopic.php', '/viewforum.php', '/memberlist.php', '/search.php', '/download/file.php'];
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link) return;
    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    if (!legacyPaths.includes(url.pathname)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    window.location.assign(url.href);
  }, true);
});